<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true"  class="link-transports" [stretchContent]="true">

  <sc-dialog-title>{{'link transports' | translate: ['tmc.link-transports-dialog.title', translationService.language]}}
  </sc-dialog-title>


  <app-transport-info-panel [carrier]="data.details.carrier" [identifier]="data.details.identifier"
    [driver]="data.details.name" [scope]="data.details.transportScope" [type]="data.details.type">
  </app-transport-info-panel>

  <sc-flex-fitting-content [vertical]="true">

    <!-- Auswahl Transport -->
    <ng-container *ngIf="currentPage === 0">
      <sc-padding [fitHeight]="true">
        <sc-flex [fitHeight]="true" [vertical]="true" [stretchContent]="true">
          <sc-title>{{'linkable transport' | translate: ['tmc.link-transports-dialog.table-header',
            translationService.language]}}</sc-title>
          <sc-content-spacer [vertical]="true"></sc-content-spacer>
          <sc-flex-fitting-content [vertical]="true">
            <sc-scroll-pane>
              <sc-tmc-table [tableModel]="tableModel" #tmcTableComponent></sc-tmc-table>
            </sc-scroll-pane>
          </sc-flex-fitting-content>
        </sc-flex>
      </sc-padding>
    </ng-container>

    <!-- Auswahl Zeitfenster -->
    <ng-container *ngIf="currentPage === 1">
      <sc-padding [fitHeight]="true">
        <sc-title>
          {{'select timeframe' | translate: ['tmc.link-transports-dialog.timeframes.title',
          translationService.language]}}
        </sc-title>
        <form #timeFrameSelectionForm="ngForm">
          <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedTimeFrame" class="timeframe-list"
            name="timeframes">
            <mat-radio-button [value]="-1" class="margin-bottom">
              {{'no timeframe' | translate:['tmc.link-transports-dialog.timeframes.no-timeframe',
              translationService.language]}}
            </mat-radio-button>
            <mat-radio-button class="margin-bottom" [value]="tf.timeframe" *ngFor="let tf of availableTimeframes">
              {{tf.timeframeDate}}</mat-radio-button>
          </mat-radio-group>
        </form>
      </sc-padding>
    </ng-container>

    <div class="messages">
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>
  </sc-flex-fitting-content>


  <sc-actionbar>
    <button mat-stroked-button (click)="showTransportSelection()" *ngIf="currentPage === 1">
      {{'previous' | translate : ['tmc.link-transports-dialog.timeframes.action.previous',
      translationService.language]}}
    </button>
    <sc-content-spacer [grow]="true"></sc-content-spacer>
    <button mat-stroked-button (click)="closeDialog()" class="cancel-button"
      [disabled]="isCloseDialogDisabled()">{{'cancel' | translate:['tmc.link-transports-dialog.action.close',
      translationService.language]}}
    </button>
    <sc-content-spacer></sc-content-spacer>
    <button mat-flat-button (click)="showTimeFrameSelection()" [disabled]="isShowTimeFrameSelection()"
      [matTooltip]="'next' | translate:['tmc.link-transports-dialog.action.next', translationService.language]"
      *ngIf="currentPage === 0 && data.details.type !== 'VEHICLE'">
      {{'next' | translate:['tmc.link-transports-dialog.action.next',
      translationService.language]}}
    </button>
    <button mat-flat-button (click)="linkTransports()" [disabled]="isLoading || this.selectedTimeFrame == null"
      [matTooltip]="'links transports' | translate:['tmc.link-transports-dialog.action.linkTransports', translationService.language]"
      *ngIf="currentPage === 1">
      {{'links transports' | translate:['tmc.link-transports-dialog.action.linkTransports',
      translationService.language]}}
    </button>
    <button mat-flat-button (click)="linkVehicleWithTransport()"
      [disabled]="isLoading || this.selectedTimeFrame == null"
      *ngIf="currentPage === 0 && data.details.type === 'VEHICLE'">
      {{'link vehicle with transport' | translate:['tmc.link-transports-dialog.action.linkVehicleWithTransport',
      translationService.language]}}
    </button>
  </sc-actionbar>

</sc-flex>
